import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3dba3f89&"
import script from "./Sidebar.ts?vue&type=script&lang=ts&"
export * from "./Sidebar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports